import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useCommissionRecalculationTaskFilterFields } from './hooks/useCommissionRecalculationTaskFilterFields';

export const CommissionRecalculationTaskListFilterChips: React.FC = () => {
  const fields = useCommissionRecalculationTaskFilterFields();

  return <FilterChips fields={fields} />;
};
